import { render, staticRenderFns } from "./BearbeitungColorierung.vue?vue&type=template&id=aed2ab8a&scoped=true&"
import script from "./BearbeitungColorierung.vue?vue&type=script&lang=js&"
export * from "./BearbeitungColorierung.vue?vue&type=script&lang=js&"
import style0 from "./BearbeitungColorierung.vue?vue&type=style&index=0&id=aed2ab8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed2ab8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VSpacer})
